export class Service {
    service_id: number;
    name: string;
    kind: string;
    product_code: string;
    limit_users: number;
    extra_users_price: number;

    constructor(
        service_id: number, 
        name: string,
        kind: string,
        product_code: string,
        limit_users: number,
        extra_users_price: number,
    ) {
        this.service_id = service_id;
        this.name = name;
        this.kind = kind;
        this.product_code = product_code;
        this.limit_users = limit_users;
        this.extra_users_price = extra_users_price;
    }

    clone(): Service {
        return new Service(
            this.service_id,
            this.name,
            this.kind,
            this.product_code,
            this.limit_users,
            this.extra_users_price,
        )
    }

    toPrimitive() {
        return {
            service_id: this.service_id,
            name: this.name,
            kind: this.kind,
            product_code: this.product_code,
            limit_users: this.limit_users,
            extra_users_price: this.extra_users_price,
        }
    }
}